module.exports = __webpack_public_path__ + "static/apple-macbook-pro-15@3x-47ad2b647f9aabbc783ed4d049bd4586.png";